import { Observable } from "rxjs/internal/Observable";
import { UseCase } from "../../base/use-case";
import { UserProfileModel } from "../../models/user/user-profile.model";
import { UserRepository } from "../../repositories/user.repository";

export class GetUserProfileUseCase implements UseCase<void, UserProfileModel> {
    constructor(private userRepository: UserRepository) { }
execute(): Observable<UserProfileModel> {
        return this.userRepository.getUserProfile();
    }
}
